<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'
import { IGroup } from '@/interfaces/entities/group'
import { ref } from 'vue'
import RateSearchBar from './RateSearchBar.vue'
const { t } = useI18n()

const emit = defineEmits<{
  (event: 'groupSelected', group: IGroup): void
}>()

const groupSelected = ref<IGroup | null>(null)
const isLoading = ref(true)

// function shareRegisters() {
//   isLoading.value = true

//   printscreen({
//     name: 'rate.png',
//     querySelector: '#rate-view-container',
//   }).finally(() => {
//     isLoading.value = false
//   })
// }

function handleGroupSelected(group: IGroup) {
  groupSelected.value = group
  emit('groupSelected', group)
}
</script>

<template>
  <div class="flex flex-col p-6 lg:px-8">
    <div class="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div class="mb-4 flex max-w-lg flex-col sm:mb-0 sm:mr-4 sm:max-w-none">
        <h1 class="pb-4 text-title-md2 font-semibold text-black">{{ t('rate.header.title') }}</h1>
        <p class="max-w-prose text-left font-medium">
          {{ t('rate.header.subtitle') }}
        </p>
      </div>

      <!-- <div class="hidden items-center justify-center pt-6 xl:flex">
        <button class="flex min-w-45 items-center justify-center gap-2 bg-green px-4 py-3 text-white hover:bg-emerald-600">
          <IcDownload v-if="isLoading" class="h-5 w-5 text-white" />
          <span v-else class="animate-spin">
            <IcAnimateSpin class="h-5 w-5 text-white" />
          </span>
          <span>{{ t('rate.header.buttons.share') }}</span>
        </button>
      </div> -->
    </div>

    <RateSearchBar @groupSelected="handleGroupSelected" />
  </div>
</template>
